import { ItemViewModel } from '@/definitions/view-models';
import { Camera } from '@/api';
import { imageLoader } from '@/store/image-loader';
import { MultisidebarItem, MultisidebarItemAttributes } from '@/store/multisidebar/types';

export default function ({ model }: MultisidebarItem<ItemViewModel<Camera>>): MultisidebarItemAttributes {
  const thumbnailSrc = model.item?.screenshot ? () => imageLoader.get(`${model.item?.screenshot}?width=100`) : undefined;
  return { label: model.item?.name || '', thumbnailSrc, thumbnailType: 'camera' };
}
